import Vue from 'vue';
import router from './router';

import VueI18n from 'vue-i18n';
import vueFilter from 'vue-filter';
import draggable from 'vuedraggable';
import trumbowyg from 'vue-trumbowyg';
import '../node_modules/trumbowyg/dist/plugins/cleanpaste/trumbowyg.cleanpaste';
import VeeValidate from 'vee-validate';
import 'trumbowyg/dist/ui/trumbowyg.css';
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';
import Notifications from 'vue-notification';
import VueApi from '@/VueApi';


/**
 * evn
 * @author https://davidwalsh.name/pubsub-javascript
 * @author Pascal Franzke <pf@linienflug.design>
 * @example
 * evn.publish('/page/load', {
 *     url: '/some/url/path' // any argument
 * });
 * var subscription = evn.subscribe('/page/load', function(obj) {
 *      // Do something now that the event has occurred
 * });
 *
 * // ...sometime later where I no longer want subscription...
 * subscription.remove();
 *
 *
 */
var evn = (function () {

    var debug = window.location.href.match(/file:\/\/|staging.|.dev|.local|localhost|linienflug.design/) ? true : false;
    var topics = {};
    var hOP = topics.hasOwnProperty;

    return {
        unsubscribe: function(topic, listener) {
            if (debug) console.debug('%c' + '/app/evn:unsubscribe | ' + topic, 'background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
            // Create the topic's object if not yet created
            if (!hOP.call(topics, topic)) topics[topic] = [];
            // doses topic exists?
            if(!topics[topic]) return true;
            // find listner
            var index = topics[topic].find(listener);
            //delete listner
            return delete topics[topic][index];
        },
        subscribe: function (topic, listener) {
            if (debug) console.debug('%c' + '/app/evn:subscribe | ' + topic, 'background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
            // Create the topic's object if not yet created
            if (!hOP.call(topics, topic)) topics[topic] = [];
            // Add the listener to queue
            var index = topics[topic].push(listener) - 1;

            // Provide handle back for removal of topic
            return {
                remove: function () {
                    delete topics[topic][index];
                }
            };
        },
        publish: function (topic, info) {
            if (debug) console.debug('%c' + '/app/evn:publish | ' + topic, 'background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
            // If the topic doesn't exist, or there's no listeners in queue, just leave
            if (!hOP.call(topics, topic)) return;

            // Cycle through topics queue, fire!
            topics[topic].forEach(function (item) {
                item(info !== undefined ? info : {});
            });
        }
    };
})();
if(typeof window.evn == 'undefined') window.evn = evn;


document.addEventListener("keydown", (e) => {
	if(e.keyCode == 27) {
		evn.publish('esc', e);
	}
	
    if (event.ctrlKey || event.metaKey) {
        switch (String.fromCharCode(event.which).toLowerCase()) {
        	case ' ':
	            evn.publish('search', e);
	            break;
	        case 's':
	            evn.publish('save', e);
	            break;
	        case 'f':
	            evn.publish('find', e);
	            break;
	        case 'c':
	            evn.publish('copy', e);
	            break;
	        case 'v':
	            evn.publish('paste', e);
	            break;
	        case 'x':
	            evn.publish('cut', e);
	            break;
		}
	}
});




// setup
Vue.config.devtools = true;
Vue.config.performance = true;
// Vue.config.productionTip = false;

Vue.directive('focus', { inserted: function (el) { el.focus() } });

Vue.use(Croppa);
Vue.use(VeeValidate);
Vue.use(Notifications);

Vue.use(VueI18n);
Vue.use(VueApi);

Vue.use(vueFilter);
Vue.use(trumbowyg);

Vue.component('draggable', draggable);

// global Comps
import VNotice 				from '@/components/v-notice';
Vue.component('v-notice',			VNotice);

import VTooldown 			from '@/components/v-tooldown';
Vue.component('v-tooldown', 		VTooldown);

import VToolinline 			from '@/components/v-toolinline';
Vue.component('v-toolinline', 		VToolinline);

import VPresentationtable 	from '@/components/v-presentationtable';
Vue.component('v-presentationtable', VPresentationtable);

import VEditorbar 			from '@/components/v-editorbar';
Vue.component('v-editorbar',		VEditorbar);

import VField 				from '@/components/v-field';
Vue.component('v-field', 			VField);

import VModal 				from '@/components/v-modal';
Vue.component('v-modal', 			VModal);

import VMainnav 			from '@/components/v-mainnav';
Vue.component('v-mainnav', 			VMainnav);

import VPaging 				from '@/components/v-paging';
Vue.component('v-paging', 			VPaging);

import VEditable 			from '@/components/v-editable';
Vue.component('v-editable', 		VEditable);
// ich hab kein plan waurm das scheiß teil nicht als recursive als child weitergeleitet wird

import CChartList 			from '@/components/p-editor/c-chart-list';
Vue.component('c-chart-list', 			CChartList);

import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/css/vue-popper.css';
Vue.component('vue-popper', 			Popper);


// lokal Comps
import store from '@/store';
import messages from '@/i18n';

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages,
});

import App from './App';

console.log('%c' + 'Linienflug Design ✈ Weil bewegt bewegt.', 'line-height: 30px; font-size: 18px; border-radius: .25em;background-color: #2b3846; color: #ffa300; padding: 3px .5em;');
window.app = new Vue({
	el: '#vapp',
	name: 'vapp',
    router,
    store,
    i18n,
    template: '<App/>',
  	components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js